import { translationFallbackEn } from './translationFallbackEn.js';

function applyReplace(text, replace) {
  if (!replace) return text;
  let out = text;
  for (const key of Object.keys(replace)) {
    out = out.split(`{{${key}}}`).join(replace[key] ?? '');
  }
  return out;
}

/** Spreadsheet/API copies often store line breaks as literal `\n` or `/n` instead of real newlines. */
function unescapeTranslationLineBreaks(text) {
  if (typeof text !== 'string') return text;
  if (!text.includes('\\') && !text.includes('/n')) return text;
  return text
    .replace(/\\r\\n/g, '\n')
    .replace(/\\n/g, '\n')
    .replace(/\\r/g, '\n')
    .replace(/\/n/g, '\n');
}

export class TranslationStore {
  constructor() {
    this.translations = {};
    this.translationsFetchOk = false;
  }

  setTranslations(fromApi) {
    this.translations = { ...(fromApi ?? {}) };
  }

  setTranslationsFetchOk(ok) {
    this.translationsFetchOk = !!ok;
  }

  t(key, replace) {
    const fromApi = this.translations[key];
    const fromFallback = translationFallbackEn[key];
    const base =
      typeof fromApi === 'string' && fromApi.length > 0
        ? fromApi
        : typeof fromFallback === 'string' && fromFallback.length > 0
          ? fromFallback
          : key;
    return unescapeTranslationLineBreaks(applyReplace(base, replace));
  }
}

export const translationStore = new TranslationStore();
